import { Interp } from '../../lib/render.jsx';

export default function ThemePopup({ v }) {
  if (!v.themePopupOpen) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" onClick={v.closeTheme} style={{ "position": "fixed", "inset": "0", "zIndex": "97", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "padding": "20px" }}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(400px,100%)", "padding": "24px", "textAlign": "center", "display": "flex", "flexDirection": "column", "gap": "14px" }}>
          <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-2)" }}>
            Thema van vandaag
          </div>
          <div style={{ "fontSize": "32px", "fontWeight": "700", "lineHeight": "1.2", "color": "var(--ink)" }}>
            <Interp v={v.themeWord} />
          </div>
          <button onClick={v.closeTheme} className="gp-btn" style={{ "justifyContent": "center", "height": "auto", "padding": "10px 16px", "background": "var(--geel)" }}>
            Aan de slag
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
